// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	restapi_url: 'https://ljhconnectv2.dnartworks.id/rest/reborn/',
	mainsite_url: 'https://ljhrealtyfrontend.dnartworks.id/',
	// restapi_url: 'http://connectv2.localhost/rest/reborn/',
	// mainsite_url: 'https://ljhrealty.com/',
	facebookAppId: '1320233224823622',
	googleClientId: '9911963967-qb69k0n5gbcsuhucnvn54ssetcml3v72.apps.googleusercontent.com',
	googleAPIkey: 'AIzaSyDbNdk1HObPSuhre8ujk0gkLbsk6KKhe-c',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
